/**
 * Set up routing for all MetricCategory views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import metricCategory views
import CreateMetricCategory from './views/CreateMetricCategory.js.jsx';
import MetricCategoryList from './views/MetricCategoryList.js.jsx';
import SingleMetricCategory from './views/SingleMetricCategory.js.jsx';
import UpdateMetricCategory from './views/UpdateMetricCategory.js.jsx';

class MetricCategoryAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleMetricCategoryUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All metric Categories', path:null}]}
          component={MetricCategoryList}
          exact
          role="admin"
          path="/admin/authoring/metric-categories"
        />
        <YTRoute
          breadcrumbs={[{display:'All metric categorie', path:'/admin/authoring/metric-categories'}, {display:'New metric Category', path:null}]}
          component={CreateMetricCategory}
          exact
          role="admin"
          path="/admin/authoring/metric-categories/new"
        />
        <YTRoute
          breadcrumbs={[{display:'All metric categories', path:'/admin/authoring/metric-categories'}, {display:'Metric Category details', path:null}]}
          component={SingleMetricCategory}
          exact
          role="admin"
          path="/admin/authoring/metric-categories/:metricCategoryId"
        />
        <YTRoute
          breadcrumbs={[{display:'All metric Categories', path:'/admin/authoring/metric-categories'}, {display:'Metric Category details', path: singleMetricCategoryUpdatePath}, {display:'Update', path:null}]}
          component={UpdateMetricCategory}
          exact
          role="admin"
          path="/admin/authoring/metric-categories/:metricCategoryId/update"
        />
      </Switch>
    )
  }
}

export default withRouter(MetricCategoryAdminRouter);



// WEBPACK FOOTER //
// modules/metricCategory/MetricCategoryAdminRouter.js.jsx